const appRoutes = {
    start: '/',
    app: '/app'
};

export default appRoutes;